import { Product } from './product-selector.model';
import { Helper } from '../utitlity/helper';

declare var TMS: any;
export abstract class TealiumAction {
    trackView(obj): any {
        var deviceType;
        if ((/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent))) {
            deviceType = 'Mobile';
        } else {
            deviceType = 'Desktop';
        }
        //   var  page = '/' + constant.USER_TYPE_PAGE_URL + '/STP/NTB/' + deviceType + '/' + obj.page_url,
        let title = '';
        if (typeof TMS !== 'undefined' && TMS) {
            try {
                console.log("entered");
                TMS.trackView({
                    page_url: obj.page_url || '',
                    page_name: obj.page_name || '',
                    page_type: obj.page_type || '',
                    page_category: obj.page_category || '',
                    page_subcategory: obj.page_subcategory || '',
                    product_id: obj.product_id || '',
                    product_category: obj.product_category || '',
                    product_subcategory: obj.product_subcategory || '',

                });
            }
            catch (e) {
                console.log("Tealium Error", e);
            }
        }
        else {
            console.log("TrackView is not found on TMS");
            console.log("tealiumObject", obj)
        }

    }
    trackEvent(obj): any {
        var deviceType;
        if ((/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent))) {
            deviceType = 'Mobile';
        } else {
            deviceType = 'Desktop'
        }
        // var page = '/' + constant.USER_TYPE_PAGE_URL + '/STP/NTB/' + deviceType + '/' + obj.page_url,
        //  title = constant.USER_TYPE_PAGE_TITLE + ':STP:NTB:' + deviceType + ':' + obj.page_title;
        if (typeof TMS !== 'undefined' && TMS) {
            try {
                TMS.trackEvent({
                    page_url: obj.page_url || '',
                    page_name: obj.page_name || '',
                    page_type: obj.page_name || '',
                    page_category: obj.page_category || '',
                    page_subcategory: obj.page_subcategory || '',
                    product_id: obj.product_id || '',
                    product_category: obj.product_category || '',
                    product_subcategory: obj.product_subcategory || '',
                    event_category: obj.event_category || '',
                    event_action: obj.event_action || '',
                    event_content: obj.event_content || '',
                    application_event : obj.application_event || ''



                });
            }
            catch (e) {
                console.log("Tealium Error", e);
            }
        }
        else {
            console.log("TrackEvent is not found on TMS");
            console.log("tealiumObject", obj)
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/models/tealium.action.ts